export default class DebugStats {
    static init(){
        this.container = document.createElement("div");
        this.container.style.position= "absolute";
        this.container.style.bottom = "0";
        this.container.style.background = "rgba(0,0,0,0.5)"
        this.container.style.right = "0";
        this.container.style.color = "aliceblue";
        this.container.style.fontSize = "12px";
        this.container.style.display = "flex";
        
        this.drawCalls = document.createElement("div");
        this.drawCallsLabel = document.createElement("div");
        this.drawCallsValue = document.createElement("div");
        this.drawCallsValue.innerText = "0";
        this.drawCallsLabel.innerText = "draws|"
        this.drawCalls.appendChild(this.drawCallsLabel);
        this.drawCalls.appendChild(this.drawCallsValue);
        document.body.appendChild(this.container);
        this.container.appendChild(this.drawCalls);

        this.polys = document.createElement("div");
        this.polysLabel = document.createElement("div");
        this.polysValue = document.createElement("div");
        this.polysValue.innerText = "0";
        this.polysLabel.innerText = "polys|"
        this.polys.appendChild(this.polysLabel);
        this.polys.appendChild(this.polysValue);
        document.body.appendChild(this.container);
        this.container.appendChild(this.polys);

        this.geos = document.createElement("div");
        this.geosLabel = document.createElement("div");
        this.geosValue = document.createElement("div");
        this.geosValue.innerText = "0";
        this.geosLabel.innerText = "geos|"
        this.geos.appendChild(this.geosLabel);
        this.geos.appendChild(this.geosValue);
        document.body.appendChild(this.container);
        this.container.appendChild(this.geos);
        
        this.textures = document.createElement("div");
        this.texturesLabel = document.createElement("div");
        this.texturesValue = document.createElement("div");
        this.texturesValue.innerText = "0";
        this.texturesLabel.innerText = "textures|"
        this.textures.appendChild(this.texturesLabel);
        this.textures.appendChild(this.texturesValue);
        document.body.appendChild(this.container);
        this.container.appendChild(this.textures);
        
    }

    static updateDrawCalls(value){
        this.drawCallsValue.innerText = value.toString();
    }

    static updatePolys(value){
        if(value){
            this.polysValue.innerText = value.toString();
        }
    }

    static updateGeos(value){
        if(value){
            this.geosValue.innerText = value.toString();
        }
    }

    static updateTextures(value){
        if(value){
            this.texturesValue.innerText = value.toString();
        }
    }
}